export default "__VITE_ASSET__kMRzraXP__"